"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EditAndCreateImage;

var _immutable = _interopRequireDefault(require("immutable"));

var _ActionTypes = require("../actions/ActionTypes");

var _Constants = require("../Constants");

var _ImageEditor = require("../utils/ImageEditor");

var defaultState = _immutable.default.Map({
  imgToEditSelected: false,
  selectedImgFrom: _Constants.ImageEditorLocations.DRAWER,
  imgSrc: '',
  imgHeight: 0,
  imgWidth: 0,
  fileName: '',
  fileId: null,
  fileFolderId: null,
  updateRequestStatus: _Constants.RequestStatus.UNINITIALIZED
});

function EditAndCreateImage() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      file = action.file,
      selectedImgFrom = action.selectedImgFrom;

  switch (type) {
    case _ActionTypes.UPLOAD_EDITED_IMAGE_ATTEMPTED:
      return state.set('updateRequestStatus', _Constants.RequestStatus.PENDING);

    case _ActionTypes.UPLOAD_EDITED_IMAGE_FAILED:
      return state.set('updateRequestStatus', _Constants.RequestStatus.FAILED);

    case _ActionTypes.UPLOAD_EDITED_IMAGE_SUCCEEDED:
      return state.merge({
        updateRequestStatus: _Constants.RequestStatus.SUCCEEDED
      });

    case _ActionTypes.IMAGE_TO_EDIT_SELECTED:
      return state.merge({
        imgToEditSelected: true,
        selectedImgFrom: selectedImgFrom || state.get('selectedImgFrom'),
        imgSrc: file.get('url'),
        fileId: file.get('id'),
        fileFolderId: file.get('folder_id'),
        fileName: file.get('name') || (0, _ImageEditor.getDefaultEditedImageName)(),
        imgHeight: file.get('height'),
        imgWidth: file.get('width'),
        encoding: file.get('encoding')
      });

    case _ActionTypes.IMAGE_TO_EDIT_DESELECTED:
      return defaultState;

    default:
      return state;
  }
}

module.exports = exports.default;